import { Navigate, useParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../../interfaces/errorResponse';
import { ICustomerFullProfile } from '../../../interfaces/customer';
import { ColumnBoxFlexFullWidth } from '../../common/boxes';
import { Loader } from '../../common/Loader';
import FreelancerPersonalInfo from './FreelancerPersonalInfo';
import Links from './Links';
import { Box } from '@mui/material';
import { createContext, Dispatch, SetStateAction, useState } from 'react';
import Resume from './Resume';
import LanguagesList from './language/LanguagesList';
import CertificateList from './certificate/CertificateList';
import EducationList from './education/EducationList';
import ExperienceList from './experience/ExperienceList';
import Availability from './availability/Availability';
import { parseAxiosError } from '../../../services/axios';
import { FREELANCERS_PATH } from '../../../router/paths';
import { TEXTS } from '../../../core/texts';
import { useGetFreelancerEntity } from '../../../queryHooks/freelancer/useGetFreelancerEntity';
import FreelancerSkills from './FreelancerSkills';
import { useNotification } from '../../../+state/useNotification';
import ProfileBullhorn from './ProfileBullhorn';

interface IFreelancerContext {
  user: ICustomerFullProfile;
  setUser: Dispatch<SetStateAction<ICustomerFullProfile | null>>;
}

export const FreelancerContext = createContext<IFreelancerContext>({} as IFreelancerContext);
export const VIEW_QUERY_PARAM_KEY = 'view';

const FreelancerEntity = () => {
  const { id } = useParams();
  const { openErrorToast, openInfoToast } = useNotification();
  const [forceNavigate, setForceNavigate] = useState(false);
  const [user, setUser] = useState<ICustomerFullProfile | null>(null);
  const { isFetching } = useGetFreelancerEntity({
    id: +id!,
    onSuccess: (user) => {
      if (!user.freelancerProfile) {
        openInfoToast(TEXTS.INCONSISTENT_CUSTOMER_TYPE);
        return setForceNavigate(true);
      }
      setUser(user);
    },
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      setForceNavigate(true);
    }
  });
  return (
    <ColumnBoxFlexFullWidth alignItems={'center'}>
      {
        isFetching && <Loader/>
      }
      {
        user && user.freelancerProfile &&
        <FreelancerContext.Provider value={{ user, setUser }}>
          <ColumnBoxFlexFullWidth maxWidth={800}>
            <Box>
              <ProfileBullhorn/>
            </Box>
            <Box mt={4}>
              <FreelancerPersonalInfo/>
            </Box>
            <Box mt={4}>
              <FreelancerSkills/>
            </Box>
            <Box mt={4}>
              <Resume/>
            </Box>
            <Box mt={4}>
              <Links/>
            </Box>
            <Box mt={4}>
              <LanguagesList/>
            </Box>
            <Box mt={4}>
              <CertificateList/>
            </Box>
            <Box mt={4}>
              <EducationList/>
            </Box>
            <Box mt={4}>
              <ExperienceList/>
            </Box>
            <Box mt={4}>
              <Availability/>
            </Box>
          </ColumnBoxFlexFullWidth>
        </FreelancerContext.Provider>
      }
      {
        forceNavigate &&
        <Navigate to={FREELANCERS_PATH}/>
      }
    </ColumnBoxFlexFullWidth>
  );
};

export default FreelancerEntity;